import React from 'react';
import { DeploymentSteps } from './DeploymentSteps';
import { NetlifyLogsButton } from '~/components/ui/NetlifyLogsButton';
import type { DeploymentProgressProps } from '~/lib/types/netlify';

export const DeploymentProgress = ({
  currentStep,
  deployedId,
  accessToken,
  deployStatus,
  adminUrl,
}: DeploymentProgressProps) => {
  return (
    <div className="space-y-4">
      <DeploymentSteps currentStep={currentStep} />

      {/* Show logs automatically during deployment */}
      {deployedId && (
        <div className="mt-4">
          <NetlifyLogsButton
            deployedId={deployedId}
            accessToken={accessToken}
            deployStatus={deployStatus}
            autoExpand={true}
            adminUrl={adminUrl}
          />
        </div>
      )}
    </div>
  );
};
